export const ExportProgressStatus = {
  DATA_DOWNLOADING: 0,
  PROCESSING_GENERATION: 1,
};
